import { render, staticRenderFns } from "./thescoreHome.vue?vue&type=template&id=486b6c90&scoped=true"
import script from "./thescoreHome.vue?vue&type=script&lang=js"
export * from "./thescoreHome.vue?vue&type=script&lang=js"
import style0 from "./thescoreHome.vue?vue&type=style&index=0&id=486b6c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486b6c90",
  null
  
)

export default component.exports